export default {
  appMenuItems: [],
  appMenuItem: undefined,
};
